import React, { FunctionComponent } from 'react';

import { PageContainer } from 'containers/page/page-container';

import TypeformModal from 'components/typeform/typeform-modal';

import { FooterContainer } from '../common/app/footer-container';
import { HeaderContainer } from '../common/app/header-container';
import { Landing2CardsContainer } from './landing-2-cards-container';
import { LandingDownloadHeroContainer } from './landing-download-hero-container';
import { LandingGetTheAppContainer } from './landing-get-the-app-container';
import { LandingHeroBlockContainer } from './landing-hero-block-container';
import { LandingLoveStoriesContainer } from './landing-love-stories-container';
import { LandingStackedCardsContainer } from './landing-stacked-cards-container';
import { LandingSubscribeContainer } from './landing-subscribe-container';

type LandingContainerProps = {
  /** Social referrals get the download block instead of the hero - JS-30122 */
  showDownloadHero?: boolean;
};

export const LandingContainer: FunctionComponent<LandingContainerProps> = ({
  showDownloadHero,
}) => {
  return (
    <PageContainer>
      <HeaderContainer />
      <main id="main" tabIndex={-1} className="project-love-main">
        {showDownloadHero ? <LandingDownloadHeroContainer /> : <LandingHeroBlockContainer />}
        <LandingStackedCardsContainer />
        <LandingSubscribeContainer />
        <Landing2CardsContainer />
        <LandingLoveStoriesContainer />
        <LandingGetTheAppContainer />
      </main>
      <FooterContainer />
      <TypeformModal />
    </PageContainer>
  );
};
